import { Box, Paper, Typography, Tooltip } from "@mui/material";
import Flag from "react-world-flags";

const CountByCountryPanel = ({ mapCountryData, paper_sx }) => (
  <Paper sx={{ ...paper_sx, maxHeight: 320, minWidth: 0 }} elevation={3}>
    <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888", mb: 1.5 }}>
      Count by country
    </Typography>
    {mapCountryData.length > 0 ? (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, maxHeight: 280, overflow: "auto" }}>
        {(() => {
          const slice = mapCountryData.slice(0, 12);
          const maxCount = Math.max(...slice.map((d) => d.count), 1);
          return slice.map((d) => (
            <Tooltip key={d.countryCode} title={`${d.countryCode} (ISO 3166-1 alpha-2)`} placement="left" arrow>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "default", minHeight: 20 }}>
                <Flag code={d.countryCode} style={{ width: 18, height: 12, borderRadius: 1, flexShrink: 0 }} />
                <Box sx={{ flex: 1, minWidth: 80, height: 14, backgroundColor: "#2a2a2a", borderRadius: 0.5, overflow: "hidden", display: "flex", alignItems: "stretch" }}>
                  <Box sx={{ width: `${(d.count / maxCount) * 100}%`, backgroundColor: "#459296", borderRadius: "inherit" }} />
                </Box>
                <Typography variant="caption" sx={{ color: "#b0b0b0", fontSize: 11, minWidth: 44, textAlign: "right", fontWeight: 500 }}>
                  {d.count.toLocaleString()}
                </Typography>
              </Box>
            </Tooltip>
          ));
        })()}
      </Box>
    ) : (
      <Typography variant="body2" sx={{ color: "#777", py: 4, textAlign: "center" }}>
        No country data.
      </Typography>
    )}
  </Paper>
);

export default CountByCountryPanel;
